import apiClient from '../../../core/services/HttpService';

export type CompensationType = 'HOURLY' | 'SALARY';

export async function getCompensation(employeeId: number) {
  const url = `/api/employees/${employeeId}/compensation/`;
  const { data } = await apiClient.get(url);
  return data;
}

export async function createCompensationPeriod(
  employeeId: number,
  payload: {
    compensation_type: CompensationType;
    hourly_rate?: string;
    salary_monthly_cents?: number;
    currency: 'EUR';
    valid_from: string;
  }
) {
  const { data } = await apiClient.post(`/api/employees/${employeeId}/compensation/`, payload);
  return data;
}

export async function createHourlyPeriod(employeeId: number, hourly: string | number, validFrom: string) {
  const hourlyDot = typeof hourly === 'string' ? hourly.replace(',', '.') : String(hourly);
  const payload = {
    compensation_type: 'HOURLY' as CompensationType,
    hourly_rate: hourlyDot,
    currency: 'EUR' as const,
    valid_from: validFrom,
  };
  const { data } = await apiClient.post(`/api/employees/${employeeId}/compensation/`, payload);
  return data;
}

export async function createSalaryPeriod(employeeId: number, monthlyEuro: string | number, validFrom: string) {
  const cents = Math.round(Number(String(monthlyEuro).replace(',', '.')) * 100);
  const payload = {
    compensation_type: 'SALARY' as CompensationType,
    salary_monthly_cents: cents,
    currency: 'EUR' as const,
    valid_from: validFrom,
  };
  const { data } = await apiClient.post(`/api/employees/${employeeId}/compensation/`, payload);
  return data;
}

export async function replaceCompensationPeriod(
  employeeId: number,
  payload: {
    compensation_type: CompensationType;
    hourly_rate?: string;
    salary_monthly_cents?: number;
    currency: 'EUR';
    valid_from: string;
  }
) {
  const { data } = await apiClient.post(
    `/api/employees/${employeeId}/compensation/?replace=1`,
    payload
  );
  return data;
}

export async function deleteCompensationPeriod(employeeId: number, validFrom: string) {
  const { data } = await apiClient.delete(
    `/api/employees/${employeeId}/compensation/?valid_from=${validFrom}`
  );
  return data;
}
